import { useAppTranslation } from "@/utils/useAppTranslation";
import { Button, Space, theme } from "@payping/web-components";
import { useEffect, useRef } from "react";
import SignaturePad from "signature_pad";

interface DrawProps {
  onFinish: (blob: Blob, data: string) => void;
  loading?: boolean;
}

const SignContractDraw = (props: DrawProps) => {
  const { t } = useAppTranslation();

  const canvasRef = useRef<HTMLCanvasElement>(null);
  const signaturePadRef = useRef<SignaturePad>(null);

  const { token } = theme.useToken();

  useEffect(() => {
    const signaturePad = signaturePadRef.current;
    const canvas = canvasRef.current;
    if (canvas) {
      const ratio = Math.max(window.devicePixelRatio || 1, 1);
      canvas.width = canvas.offsetWidth * ratio;
      canvas.height = canvas.offsetHeight * ratio;
      canvas.getContext("2d")?.scale(ratio, ratio);
      (signaturePadRef as any).current = new SignaturePad(canvas, { backgroundColor: "#ffffff", penColor: "#000000" });
    }
    return () => {
      if (signaturePad) {
        signaturePad.clear();
        signaturePad.off();
      }
    };
  }, [canvasRef]);

  const clearDraw = () => {
    const signaturePad = signaturePadRef.current;
    if (signaturePad) {
      signaturePad.clear();
    }
  };

  async function confirmDraw() {
    if (props.loading) {
      return;
    }
    const signaturePad = signaturePadRef.current;

    if (signaturePad) {
      if (signaturePad.isEmpty()) {
        // notification.error({
        //   message: String(t("pay.getOrder.steps.uploadSignature.form.errorForDraw")),
        //   closable: true,
        // });
      }

      const data = signaturePad.toDataURL("image/jpeg");

      const blob = await (await fetch(data)).blob();

      props.onFinish(blob, data);
    }
  }

  return (
    <Space direction="vertical" className="w-100">
      <canvas
        className=" w-100"
        style={{ border: "1px solid", borderColor: token.colorBorder, height: "40dvw" }}
        ref={canvasRef}
      ></canvas>
      <Space className="w-100 justify-center">
        <Button
          size="large"
          onClick={() => {
            clearDraw();
          }}
        >
          {t("signContract.redraw")}
        </Button>
        <Button
          size="large"
          loading={props.loading}
          type="primary"
          onClick={() => {
            confirmDraw();
          }}
        >
          {t("signContract.sign")}
        </Button>
      </Space>
    </Space>
  );
};

export default SignContractDraw;
